import RegisterFutureSuccess from './register-future-success-container';

export default RegisterFutureSuccess;
